enum SortAlgo {
  BubbleSort = 'BubbleSort',
  HeapSort = 'HeapSort',
  InsertionSort = 'InsertionSort',
  QuickSort = 'QuickSort',
}
export default SortAlgo;
